<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
        <img src="static/images/popups/prize-spin.svg" class="op_down_img">
        <p><b>{{ getBundleData.numberOfCoins ? getBundleData.numberOfCoins + ' ' + getTranslations.home_modals_confirm_purchase_games :''}}
          {{getBundleData.numberOfCoins && getBundleData.points ? getTranslations.home_modals_confirm_purchase_successfull_and :''}}
          {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_store_points : '' }}
          – {{ getBundleData.price}} {{ getBundleData.currencyCode }}</b></p>
        <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
        <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';

export default {
  name: 'confirmPurchaseViaSms',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseViaSms.vue